import React, { useState } from 'react';

const MessageInput = ({ isConnected, onSendMessage, messagesContainerRef }) => {
  const [newMessage, setNewMessage] = useState('');

  const handleSendMessage = (e) => {
    e.preventDefault();
    
    if (newMessage.trim() && isConnected) {
      onSendMessage(newMessage);
      
      setNewMessage('');
      
      setTimeout(() => {
        const el = messagesContainerRef?.current;
        if (!el) return;
        el.scrollTo({ top: el.scrollHeight, behavior: 'smooth' });
      }, 0);
    }
  };

  const handleInputChange = (e) => {
    setNewMessage(e.target.value);
  };

  return (
    <div className="message-input-container">
      <form className="message-form" onSubmit={handleSendMessage}>
        <input
          type="text"
          className="message-input"
          value={newMessage}
          onChange={handleInputChange}
          placeholder="Введите сообщение..."
          disabled={!isConnected}
          autoFocus
        />
        <button 
          type="submit" 
          className="send-btn"
          disabled={!isConnected || !newMessage.trim()}
        >
          <img src="/assets/images/send.svg" alt="Send" />
        </button>
      </form>
    </div>
  );
};

export default MessageInput;
